import * as types from './types';

export function toggleLeftSidenav() {
  return {
    type: types.TOGGLE_LEFT_SIDENAV,
  };
}

export function toggleRightSidenav() {
  return {
    type: types.TOGGLE_RIGHT_SIDENAV,
  };
}
